// extracted by mini-css-extract-plugin
export default {"root":"admin_page_root__KH2FR","tab_root":"admin_page_tab_root__K7U5d"};